var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-toggle":"tooltip","data-placement":"left","data-html":"true","title":_vm.tooltipContent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }